import { render, staticRenderFns } from "./detailModal.vue?vue&type=template&id=3a4d64cf&scoped=true"
import script from "./detailModal.vue?vue&type=script&lang=js"
export * from "./detailModal.vue?vue&type=script&lang=js"
import style0 from "./detailModal.vue?vue&type=style&index=0&id=3a4d64cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4d64cf",
  null
  
)

export default component.exports